import React from "react";
import { Link } from "gatsby";
import RevealAnimation from "../RevealAnimation";
import "./powerhouseTeamSection.scss";
import KarthikImg from "../../assets/Images/newAboutUs/karthik-kumar.png";
import RameshImg from "../../assets/Images/newAboutUs/ramesh.png";
import {
  FiCpu,
  FiCode,
  FiTarget,
  FiLayout,
  FiDatabase,
  FiCloud,
  FiCheckCircle,
  FiArrowRight,
  FiZap,
  FiUsers,
  FiBox,
  FiShield,
  FiMaximize,
} from "react-icons/fi";

const PowerhouseTeamSection = () => {
  const roles = [
    { name: "Enterprise Architects", icon: <FiCpu /> },
    { name: "Senior Software Engineers", icon: <FiCode /> },
    { name: "Product Strategists", icon: <FiTarget /> },
    { name: "UX/UI Specialists", icon: <FiLayout /> },
    { name: "Data & Analytics Engineers", icon: <FiDatabase /> },
    { name: "SRE / DevOps", icon: <FiCloud /> },
    { name: "Automation QA", icon: <FiCheckCircle /> },
  ];

  const benefits = [
    { text: "Already performing - no forming/storming", icon: <FiZap /> },
    { text: "Mastermind model = 8-10x thinking power", icon: <FiUsers /> },
    { text: "Builds MMPs, not prototypes", icon: <FiBox /> },
    { text: "Reduces execution risk dramatically", icon: <FiShield /> },
    { text: "Can scale or extend instantly", icon: <FiMaximize /> },
  ];

  return (
    <section className="powerhouse-team-section" id="powerhouse-team">
      <div className="container">
        <RevealAnimation>
          <div className="section-header">
            <span className="section-badge">The Powerhouse Team</span>
            <h2>Your Day-One Engineering Org</h2>
            <p className="subtitle">
              The Fastest Way to Build a High-Quality Product
            </p>
            <p className="description">
              Founders get a ready-made, performing engineering organisation
              from day one. No hiring delays, no team building friction.
            </p>
          </div>
        </RevealAnimation>

        <div className="team-grid">
          <RevealAnimation>
            <div className="squad-container">
              <h3>digiRyte’s Elite Cross-Functional Squad</h3>
              <div className="roles-grid">
                {roles.map((role, index) => (
                  <div className="role-card" key={index}>
                    <div className="role-icon">{role.icon}</div>
                    <span>{role.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </RevealAnimation>

          <div className="leadership-container">
            <div className="leaders-row">
              <RevealAnimation delay={0.2}>
                <Link
                  to="/about-us/leadership/?profile=Karthik-Kumar"
                  className="leader-card"
                >
                  <div className="leader-avatar">
                    <img src={KarthikImg} alt="Karthik Kumar" />
                  </div>
                  <div className="leader-info">
                    <h4>Karthik Kumar</h4>
                    <p>CTO, digiRyte</p>
                  </div>
                </Link>
              </RevealAnimation>

              <RevealAnimation delay={0.3}>
                <Link
                  to="/about-us/leadership/?profile=Ramesh-Raja"
                  className="leader-card"
                >
                  <div className="leader-avatar">
                    <img src={RameshImg} alt="Ramesh Raja" />
                  </div>
                  <div className="leader-info">
                    <h4>Ramesh Raja</h4>
                    <p>Field CTO, digiRyte</p>
                  </div>
                </Link>
              </RevealAnimation>
            </div>

            <RevealAnimation delay={0.4}>
              <div className="benefits-list">
                <h3>Why Powerhouse Works</h3>
                <ul>
                  {benefits.map((benefit, index) => (
                    <li key={index}>
                      <span className="benefits-check-icon">
                        {benefit.icon}
                      </span>
                      {benefit.text}
                    </li>
                  ))}
                </ul>
                <div className="card-cta">
                  <Link to="/about-us/" className="btn-primary">
                    Meet the Powerhouse Team <FiArrowRight />
                  </Link>
                </div>
              </div>
            </RevealAnimation>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PowerhouseTeamSection;
